<template>
  <BoardView :title="$t('title')">
    <FormValidation @submit="create">
      <FormUser type="admin" :user="user" />
      <Btn v-if="hasRole('>=ADMIN')" class="info" :isLoading="isSaving" type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardAdd from '@mixins/BoardAdd'
import FormUser from '@forms/FormUser'

export default {
  mixins: [BoardAdd('user', 'Users', { role: 'ADMIN' })],
  components: { FormUser },
}
</script>

<i18n>
{
  "en": {
    "title": "Add a user",
    "submit": "Save"
  }
}
</i18n>
